import { Message } from '../message.model';

export interface ResponseConsolidatedFlow {
  column_name: ColumnNameConsolidatedFlow | Message;
}

export interface ColumnNameConsolidatedFlow {
  "public data": DataConsolidatedFlow;
}

export interface DataConsolidatedFlow {
  anio_base:     number;
  anio_anterior: number;
  fechas:        DateConsolidatedFlow[];
  resumen:       SummaryConsolidatedFlow;
}

export interface DateConsolidatedFlow {
  "Periodo Fecha":              string;
  "Periodo Fecha año anterior": string;
  "Flujo":                      number;
  "Flujo año anterior":         number;
  "Comparacion_base":           string;
  "Comparacion_anterior":       string;
}

export interface SummaryConsolidatedFlow {
  total_flujo_act:    number;
  total_flujo_com:    number;
  diferencia:         number;
  porcentaje:         string;
  porcentaje_decimal: number;
  indicador:          string;
}
